module.exports = __webpack_public_path__ + "static/media/substraction.35248135.svg";